import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Portal footer — minimal meta strip (TWS-108 Wave 6).
 *
 * One-line bar that sits in the `.tw-layout` `footer` grid area. Left side
 * shows the copyright / locale; right side a row of utility links. Styling
 * comes from `_footer.scss` (glass-blur 8 px, divider top border).
 *
 * Design authority: handoff `src/app.jsx` lines 144-149,
 * `shell.css` lines 840-852.
 */
@Component({
  standalone: true,
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  /** Current year for the copyright line — evaluated once at component boot. */
  protected readonly year = new Date().getFullYear();
}
